<template>
    <vx-expandable-card>
        <template v-slot:header> Billing Contact </template>

        <template v-slot:content>
            <form @submit.prevent="submit" class="flex flex-col gap-6 mt-3" data-test="update-billing-contact">
                <vx-alert data-test="info-alert" :closeable="false">
                    <template v-if="canUpdate"> Here you may set a custom billing contact email address. </template>
                    <template v-else> Billing contact email address may only be changed by the team owner. </template>
                </vx-alert>

                <div>
                    <vx-label for="billing-email">Email Address</vx-label>
                    <vx-input
                        v-model="data.email"
                        :disabled="!canUpdate"
                        id="billing-email"
                        name="email"
                        type="text"
                        size="lg"
                        :error="displayFirstError(validation.email)"
                    />
                </div>

                <vx-button v-if="canUpdate" size="lg" type="submit" :loading="processing">
                    Update
                </vx-button>
            </form>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxAlert, VxButton, VxInput, VxExpandableCard, VxLabel } from '@voxie/frontend-components';
import { computed, ref } from 'vue';
import { useFormSubmission } from '~/composables/useFormSubmission';
import { displayFirstError } from '~/utils/validation';
import axios from '~/services/axios';
import { email } from '@vuelidate/validators';

const props = defineProps({
    team: {
        type: Object,
        required: true,
    },
    ownsTeam: Boolean,
    isTeamAdmin: Boolean,
});

const data = ref({
    email: props.team.billing_email,
});

const canUpdate = computed(() => props.ownsTeam || props.isTeamAdmin);

const { validation, submit, processing } = useFormSubmission({
    data,
    validation: {
        email: {email: email}
    },
    submit: () => axios.put(`/settings/teams/${props.team.id}/billing-contact-email-address`, data.value),
    notification: {
        message: 'Billing Contact Email updated',
    },
});
</script>
